/* eslint-disable max-params */

const S5_IMAGE_PATH_CUTOFF_YEAR = 2024;
const RELEASED_AT_S5_CUTOFF_MS = Date.UTC(S5_IMAGE_PATH_CUTOFF_YEAR, 0, 1, 0, 0, 0, 0);
const UNIX_TIMESTAMP_MS_LOWER_BOUND = 1_000_000_000_000;
const MILLISECONDS_PER_SECOND = 1000;

const getIdertifierImage = (identifier: string): string => identifier.split(':').pop();

const usercontentImageSizePrefix = (releasedAt?: number | null): 's3' | 's5' => {
    if (releasedAt === null || releasedAt === 0) {
        return 's3';
    }

    const ms = releasedAt < UNIX_TIMESTAMP_MS_LOWER_BOUND
        ? releasedAt * MILLISECONDS_PER_SECOND
        : releasedAt;

    return ms < RELEASED_AT_S5_CUTOFF_MS ? 's3' : 's5';
};

export const size380x380 = (
    provider: string,
    identifier: string,
    releasedAt?: number | null,
    inOut?: boolean,
    imageUrl?: string | null
): string => {
    if (inOut && imageUrl) {
        return imageUrl;
    }

    const identifierImage = getIdertifierImage(identifier);
    const sizePath = usercontentImageSizePrefix(releasedAt);

    return `https://usercontent.cc/i/${sizePath}/${provider}/${identifierImage}.png`;
};

export const size190x190 = (
    provider: string,
    identifier: string,
    releasedAt?: number | null,
    inOut?: boolean,
    imageUrl?: string | null
): string => {
    if (inOut && imageUrl) {
        return imageUrl;
    }

    const identifierImage = getIdertifierImage(identifier);
    const sizePath = usercontentImageSizePrefix(releasedAt);

    return `https://usercontent.cc/i/${sizePath}/${provider}/${identifierImage}.png`;
};

export const size1600x900 = (
    provider: string,
    identifier: string,
    inOut?: boolean,
    imageUrl?: string | null
): string => {
    if (inOut && imageUrl) {
        return imageUrl;
    }

    const identifierImage = getIdertifierImage(identifier);
    return `https://usercontent.cc/${provider}/${identifierImage}.jpg`;
};
